// Lightweight registry of the blog articles — slug, title, excerpt, read time — in publish order.
//
// The homepage "Guides from the field" cards and the static SEO pages need these four fields on
// every route, but must not pull data/blog.js (the full article bodies) into the shared bundle.
// blog.js imports ARTICLE_INDEX and fails loudly if the two ever drift apart.
export const ARTICLE_INDEX = [
  {
    slug: 'heat-pump-vs-gas-furnace-western-washington',
    title: 'Heat Pump vs. Gas Furnace in Western Washington: What Actually Makes Sense in 2026',
    excerpt: 'The heat pump vs. furnace question comes up in almost every in-home visit we do. Here is the honest, Puget Sound\u2013specific answer \u2014 including the cases where a furnace still wins.',
    readTime: '7 min read',
  },
  {
    slug: 'hvac-installation-cost-puget-sound',
    title: 'What a New HVAC Installation Costs in the Puget Sound Area (And What Drives the Price)',
    excerpt: 'Nobody publishes real numbers, so we will. Here are the installed price ranges we see across King, Pierce, and Snohomish counties \u2014 and exactly what pushes a project to the top or bottom of its range.',
    readTime: '8 min read',
  },
  {
    slug: 'gas-to-electric-conversion-rebates-panel-requirements',
    title: 'Converting from Gas to Electric Heat: Rebates, Panel Requirements, and What to Expect',
    excerpt: 'Gas-to-electric conversions are the fastest-growing project type we install. Here is the complete picture \u2014 panel capacity, rebates, timeline, and the questions to ask before you commit.',
    readTime: '8 min read',
  },
];

export const ARTICLE_SLUGS = ARTICLE_INDEX.map((a) => a.slug);
export const articlePath = (slug) => `/blog/${slug}`;

/** [label, path] pairs for every article except `slug` (the "Related guides" set). */
export const relatedArticleLinks = (slug) => ARTICLE_INDEX.filter((a) => a.slug !== slug).map((a) => [a.title, articlePath(a.slug)]);
